import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { ScrollArea, Title } from "@mantine/core";
import { useNetwork } from "@mantine/hooks";

import { StyledWithDashboardNavbar } from "@layouts/WithDashboardNavbar/WithDashboardNavbar.styled";
import { StyledWrapper } from "@layouts/WithPatientNavbar/WithPatientNavbar.styled";

import { NetworkNotification } from "@components/NetworkNotification";

import { getAppointmentNavLinks } from "@data/appointmentNavLinks";

import { useAuth } from "@contexts/auth";


interface WithDashboardNavbarProps {
  children: React.ReactNode;
}

export const WithAppointmentsNavbar = ({
  children,
}: WithDashboardNavbarProps) => {
  const { t } = useTranslation();

  const { online } = useNetwork();
  const { roles , canAccessPath } = useAuth();

  return (
    <>
      <NetworkNotification />
      <StyledWithDashboardNavbar
        className={`${!online ? "show-notification" : "hide-notification"}`}>
        <div className="upper-nav">
          <Title order={2} fz={22} fw={500}>
            {t("appointments")}
          </Title>
        </div>

        <ScrollArea>
          <ul className="nav-links">
            {getAppointmentNavLinks(canAccessPath, roles).map(item => (
              <li
                className={`nav-links-item ${
                  !item.isEnabled ? "disabled" : ""
                }`}
                key={item.link}>
                <NavLink to={`/appointments/${item.link}`}>
                  {item.title}
                </NavLink>
              </li>
            ))}
          </ul>
        </ScrollArea>
      </StyledWithDashboardNavbar>
      <StyledWrapper
        className={`${!online ? "show-notification" : "hide-notification"}`}>
        {children}
      </StyledWrapper>
    </>
  );
};
